import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import axios from "axios";
import Datatable from "../Components/Datatable"
import { API_BASE_URL } from "../../../../Helpers/apiConfig";

function ManagerSearchList() {
    const { user } = useAuth();
    const { t } = useTranslation()
    const [msg, setMsg] = useState([]);
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState(true);


    const columnsClass = React.useMemo(
        () => [
            {
                Header: 'Sınıf Adı',
                Footer: 'Sınıf Adı',
                accessor: 'className', // accessor is the "key" in the data
            },
            {
                Header: 'Sınıf Açıklaması',
                Footer: 'Sınıf Açıklaması',
                accessor: 'description',
                id: 'classDescription',
            },
            {
                Header: 'Öğrenci Adeti',
                Footer: 'Öğrenci Adeti',
                accessor: 'studentCount',
            },
            {
                Header: 'Düzenle',
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">
                        <button
                            className="btn btn-warning mr-2  btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            Sınıfın Öğrencilerini Getir
                        </button>
                    </div>
                ),
                id: 'action',
                Footer: 'Düzenle',
            },
        ],
        [],
    )

    const handleEdit = (row) => {
        window.location.href = "/school/studentlist/" + row['id'];
    }
    useEffect(() => {
        const fetchdata = async () => {
            setLoading(true);

            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = `${API_BASE_URL}/manager/EditSchool/GetClasses`;
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            for (let i = 0; i < res.data['data'].length; i++) {
                                classes.push({
                                    "id": res.data['data'][i]['id'],
                                    "className": res.data['data'][i]['className'],
                                    "description": res.data['data'][i]['description'],
                                    "studentCount": res.data['data'][i]['studentCount'],
                                })
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }


            setLoading(false);
        }
        fetchdata();
    }, [])

    return (
        <div>


            <div style={{ textAlign: "center" }}>
                <h3>{msg}</h3>
                <h1>{t("classlist")}</h1>
                {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loading && (
                    <div>
                        <Datatable data={classes} columns={columnsClass} tableBaslik={t("classlist")} />
                    </div>
                )}
            </div>

        </div>
    );
}

export default ManagerSearchList;

